import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ClientesService {

  constructor(private afDB:AngularFireDatabase, private afs:AngularFirestore,private http:HttpClient) { }

  // Obtiene todos los clientes
  public obtenerTodosLosClientes(){
    return this.afDB.list('/clientes/');
  }

  public insertarClienteBackup(key_cliente,data_cliente,tabla) {
    let multipathUpdate = {};
    multipathUpdate['/clientes'+tabla+'/' + key_cliente] = data_cliente;
    return Promise.all([this.afDB.object('/').update(multipathUpdate), key_cliente]);
}

  // Crea un nuevo nodo de clientes
  public crearCliente(cliente){
    this.incrementarConsecutivoClientes(cliente.numeroDeCliente + 1);
    return this.afDB.list('/clientes/').push(cliente);
  }

  public crearClienteAgencia(cliente){
    const firebaseIdCliente = this.afs.createId();
    let client_to_save = {
      nombre: cliente.nombre,
      numeroDeCliente: cliente.numeroDeCliente,
      idHubspot: cliente.idHubspot,
      personalCreador: cliente.personalCreador,
      metodoDeCotizacion: cliente.metodoDeCotizacion,
      notas: cliente.notas,
      tipoCliente: cliente.tipoCliente,
      confirmacionesTotales: cliente.confirmacionesTotales,
      fechaDeCreacion: cliente.fechaDeCreacion,
      estatus: cliente.estatus,
    }
    let batch = this.afs.firestore.batch();
    batch.set(this.afs.firestore.collection('clientesPorAgencia').doc(firebaseIdCliente),client_to_save);
    let promise = batch.commit();
    return Promise.all([promise,{$key: firebaseIdCliente}]);
  }

  public updateClienteAgencia(key_cliente, key_agencia)
  {
    return this.afs.collection('clientesPorAgencia').doc(key_agencia).update({
      key_cliente_agencia : key_cliente,
  });
  }

  // Obtiene el último número consecutivo
  public obtenerConsecutivoClientes(){
    return this.afDB.object('contadores/numeroClientes');
  }

  // Incrementa el número consecutivo de clientes
  private incrementarConsecutivoClientes(numero){
    this.afDB.object('contadores/numeroClientes').set(numero);
  }

  // Cambia el nombre del cliente de los diferentes nodos donde se necesita
  public cambiarNombre(idCliente, nombre){
    return this.afDB.object('clientes/' + idCliente + '/nombre').set(nombre);
  }

  // Cambia el estatus del cliente
  public cambiarEstatusCliente(idCliente, estatus){
    return this.afDB.object('clientes/' + idCliente + '/estatusCliente').set(estatus);
  }
    public cambiarMetodoCotizacion(idCliente, metodoDeCotizacion){
        return this.afDB.object('clientes/' + idCliente + '/metodoDeCotizacion').set(metodoDeCotizacion);
    }
    public cambiarEstatusNegociacion(idCliente, estatus){
        return this.afDB.object('clientes/' + idCliente + '/estatusNegociacion').set(estatus);
    }
    public cambiarTipoCliente(idCliente, estatus){
        return this.afDB.object('clientes/' + idCliente + '/tipoCliente').set(estatus);
    }
    public cambiarSeguimientoAutomaticoEmpresa(idCliente: string, valor: string){
        return this.afDB.object('clientes/' + idCliente + '/seguimientoAutomaticoDeEmpresa').set(valor);
    }
  // Cambia los datos fiscales del cliente
  public cambiarDatosFiscales(idCliente, datosFiscales){
    return this.afDB.object('clientes/' + idCliente + '/datosFiscales').set(datosFiscales);
  }

  // Obtener objeto y regresa cliente
  public obtenerCliente(idCliente){
    return this.afDB.object('clientes/' + idCliente);
  }

  // Obtener objeto y regresa cliente
  public obtenerClientePorPersonalCreador(idUsuarioPersonal){
    return this.afs.collection('clientesPorAgencia', ref => ref.where('personalCreador','==',idUsuarioPersonal));
  }

  // OBtiene los datos fiscales del cliente
  public obtenerDatosFiscales(idCliente){
    return this.afDB.object('clientes/' + idCliente + '/datosFiscales');
  }

  // Obtiene personal creador del cliente
  public obtenerPersonalCreador(idUsuarioPersonal){
    return this.afDB.object('usuariosPersonal/' + idUsuarioPersonal + '/informacionPersonal/nombre');
  }
   // Obtener objeto y regresa cliente
   public obtenerPropiedadCliente(idCliente, propiedad){
    return this.afDB.object('clientes/' + idCliente+ '/'+ propiedad);
  }

  /**
   * Cambia el proceso de pago del cliente
   * @param procesoNuevo
   */
  public cambiarProcesoDePago(idCliente:string, procesoNuevo:string){
    return this.afDB.object('/clientes/' + idCliente + '/procesoDePago/').set(procesoNuevo);
  }


    public editarNotasCliente(idCliente:string, notas:string){
        return this.afDB.object('/clientes/' + idCliente + '/notas/').set(notas);
    }
    public actualizarConfirmacionesCliente(idCliente:string, confirmacionesTotales:number){
        return this.afDB.object('/clientes/' + idCliente + '/confirmacionesTotales/').set(confirmacionesTotales);
    }
    public actualizarComprasCliente(idCliente:string, compras:number){
        return this.afDB.object('/clientes/' + idCliente + '/historicoCompraCliente/').set(compras);
    }
    public actualizarUltimaConfirmacionCliente(idCliente:string, fecha:number){
        return this.afDB.object('/clientes/' + idCliente + '/ultimaConfirmacion/').set(fecha);
    }

    public obtenerRutasCorporativas(idCliente:string) {
      return  this.afs.collection('ruasPorCliente').doc(idCliente);
    }

    public agregarRutaCorporativa(idCliente:string, ruta:string) {
        return this.afDB.list(`/clientes/${idCliente}/rutas/`).push(ruta.trim());
    }

    public crearClienteHubSpot(cliente){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'nombre=' + encodeURIComponent(cliente.nombre) +
            '&telefono='+encodeURIComponent(cliente.telefono)+
            '&de_donde_llego='+encodeURIComponent(cliente.metodoDeCotizacion)+
            '&seguimiento_automatico_de_empresa='+encodeURIComponent(cliente.seguimientoAutomaticoDeEmpresa);

        return this.http.post('https://operacion.trosten.com/hubspot-service/Cliente/crearCliente.php', body,{headers});
    }

    public actualizarSeguimientoAutomaticoEmpresaHubSpot(idHubspot: string, valor: string){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'idHubspot=' + encodeURIComponent(idHubspot) + '&valor=' + encodeURIComponent(valor);
        return this.http.post('https://operacion.trosten.com/hubspot-service/Cliente/updateCliente.php', body, {headers});
    }

    public actualizarIdHubspotCliente(idCliente:string, id:string){
        return this.afDB.object('/clientes/' + idCliente + '/idHubspot/').set(id);
    }

    public subirTarifario(file: File, idCliente: string) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('idCliente', idCliente);
        return this.http.post<any>(
            'https://operacion.trosten.com/corp-school/php/admin/Documentos/subirTarifarioCliente.php',
            formData
        );
    }

    public guardarTarifarioCliente(idCliente: string, tarifario: any) {
        return this.afDB.object('/clientes/' + idCliente + '/tarifario/').set(tarifario);
    }

    public eliminarTarifarioCliente(idCliente: string) {
        return this.afDB.object('/clientes/' + idCliente + '/tarifario/').remove();
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/clientes.service.ts